import React from 'react';
import {useSelector} from 'react-redux';

import {contentUrlSolver} from '../../helpers';

import {Container} from './ShowsGrid.styles';
import ContentBox from '../ContentBox';

function ShowsGrid({items, onClickItem, isFavouritesGrid, cnito, onlyChild}) {
    const config = useSelector(state => state.config);

    const renderContent = items.map(item => (
        <ContentBox
            key={item.id}
            id={item.id}
            data={item}
            favouritesGrid={isFavouritesGrid}
            highlight={item.highlight}
            title={item.title}
            background={contentUrlSolver(
                config,
                item.image,
                'BACKGROUND',
                'png',
                '?imwidth=300',
            )}
            action={() => onClickItem(item.title, item)}
            cnito={cnito}
        />
    ));

    return onlyChild ? (
        renderContent
    ) : (
        <Container cnito={cnito}>{renderContent}</Container>
    );
}

export default ShowsGrid;
